import PropTypes from 'prop-types';
import AidRectCheckbox from '../AidRectCheckbox';
import { RectCheckboxGroupContextProvider } from '../../utils/rectCheckboxContext';
import rectCheckbox from './groupRectCheckbox.module.scss';

function GroupRectCheckbox(props) {
  const {
    options, defaultValue, style, onChange, unit,
  } = props;

  const onRectCheckboxChange = (e) => {
    onChange(e);
  };

  const renderRectCheckbox = () => options.map((item) => (
    <AidRectCheckbox
      key={item.key}
      index={item.key}
      text={item.name}
      checked={defaultValue === item.key}
      style={style}
      icon={item.icon}
      unit={unit}
    />
  ));

  return (
    <RectCheckboxGroupContextProvider value={{ onChange: onRectCheckboxChange }}>
      <div className={rectCheckbox['rect-checkbox']}>
        {
          renderRectCheckbox()
        }
      </div>
    </RectCheckboxGroupContextProvider>
  );
}

GroupRectCheckbox.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  defaultValue: PropTypes.string,
  unit: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
};
GroupRectCheckbox.defaultProps = {
  options: [],
  defaultValue: '',
  style: {},
  unit: 'rem',
  onChange: () => {},
};

export default GroupRectCheckbox;
